import { colors, fonts } from 'components/styles/variables';

export function filtersModalStyles(isModalOpen: boolean): string {
  return `
  .filters-modal-paper {
    width: 100%;
  }
  @media (min-width: 600px) {
    .filters-modal-paper {
      width: 360px;
      right: 0;
    }
  }
  .filters-modal-header {
    background-color: ${colors.WHITE};
    position: sticky;
    top: 0;
    z-index: 20;
    border-bottom: 1px solid ${colors.G2};
  }
  .filters-modal-header-top-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px;
  }
  .filters-modal-header-title {
    color: ${colors.BLACK};
    font-family: ${fonts.default};
    font-weight: 700;
    font-size: 22px;
    line-height: 32px;
    letter-spacing: 0.2px;
    text-transform: none;
  }
  .filters-modal-filters-list-outer {
    overflow: scroll;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .filters-modal-filters-list {
    background-color: ${colors.G1};
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-start;
    padding: 16px;
  }
  .filters-modal-footer {
    background-color: ${colors.WHITE};
    width: 100%;
    position: sticky;
    bottom: 0;
    border-top: 1px solid ${colors.G2};
    height: 68px;
  }
  html {
    position: ${isModalOpen ? 'fixed' : ''};
    width: ${isModalOpen ? '100%' : ''};
  }
`;
}
